<template>
  <div class="maintain">
    <div class="message">
      <img class="ico" src="@/assets/images/user/blueTipIcon.png"/>
      <p>共享车辆在平台共享期间，累计行驶里程达5000公里， 即可享受平台赠送免费保养一次。</p>
    </div>
    <div class="content">
      <div class="carCon" v-for="(item,index) in list" :key="index">
        <div class="item">
          <span>保养时间</span>
          <span class="value">{{item.Time}}</span>
        </div>
        <div class="item">
          <span>保养地点</span>
          <span class="value">{{item.Adress}}</span>
        </div>
        <div class="item">
          <span>保养类型</span>
          <span class="value">{{item.Mode}}</span>
        </div>
        <div class="item">
          <span>保养费用</span>
          <span class="value">{{item.Charge}}</span>
        </div>
        <div class="item">
          <span>保养明细</span>
          <span class="value">{{item.Detail}}</span>
        </div>
      </div>

      <div class="nodata" v-if="list.length == 0">
        <img class="img" src="@/assets/images/peccancy/nodata.png"/>
        <div>暂无事故~</div>
      </div>
      <div v-else class="end">没有更多啦~</div>
    </div>
  </div>
</template>

<script>
  import { maintainList } from "@/utils/api";
  export default {
    name: 'maintain',
    data: function () {
      return {
        CarID:0,
        list:[]
      };
    },
    created() {
      this.CarID = this.$route.query.CarID || 0;
    },
    mounted() {
      this.initData();
    },
    methods: {
      async initData(){
        let res = await maintainList({
          data:{
            CarId:this.CarID
          }
        })
        if(res.Code == 100){
          for(var i=0;i<res.Data.length;i++){
            res.Data[i].Time = res.Data[i].Time.slice(0,16).replace('T','  ');
          }
          this.list = res.Data;
        }
      }
    }
  }

</script>

<style lang="scss" scoped type="text/scss">
  .maintain{
    position: absolute;
    width: 100%;
    top: 110px;
    bottom: 0px;
    left: 0px;
    background: #fff;
    .message{
      display: flex;
      justify-content: space-between;
      padding: 20px;
      box-sizing: border-box;

      color: #027FFF;
      font-size: 26px;
      .ico{
        margin-right: 10px;
        width: 40px;
        height: 40px;
      }
    }
    .content{
      padding: 25px;
      box-sizing: border-box;
      .carCon{
        margin-bottom: 30px;
        padding: 10px 0;
        box-sizing: border-box;
        box-shadow:-3px 6px 15px #ccc;
        -webkit-box-shadow:-3px 6px 15px #ccc ;
        .item{
          display: flex;
          justify-content: space-between;
          padding: 22px 34px;
          box-sizing: border-box;
          color: #9F9F9F;
          font-size: 26px;
          .value{
            color: #000;
          }
          span{
            min-width: 70px;
          }
        }
      }
      .nodata {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
        margin-top: 200px;
        box-sizing: border-box;
        color: #9F9F9F;
        .img{
          width: 300px;
          height: 180px;
          margin-bottom: 20px;
        }
      }
      .end{
        margin-top: 30px;
        text-align: center;
        color: #797979;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/car/maintain.vue